import Model from './Model'

export default class SystemMessageTriggerModel extends Model {
  public id: number|undefined
    public name: string|undefined

    resource () : string {
      return 'system-message-triggers'
    }

    /**
   * add update function that accepts data and an id
   */
    update (id: number, data: any) : Promise<any> {
      return this.request({
        method: 'put',
        url: this.resource() + '/' + id,
        data
      })
    }
}
